import { render, staticRenderFns } from "./slack_alert_logs.vue?vue&type=template&id=b29df156&"
import script from "./slack_alert_logs.vue?vue&type=script&lang=js&"
export * from "./slack_alert_logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports